import { render, staticRenderFns } from "./menu-compo-grid.vue?vue&type=template&id=e280bc14"
import script from "./menu-compo-grid.vue?vue&type=script&lang=ts"
export * from "./menu-compo-grid.vue?vue&type=script&lang=ts"
import style0 from "./menu-compo-grid.vue?vue&type=style&index=0&id=e280bc14&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e280bc14')) {
      api.createRecord('e280bc14', component.options)
    } else {
      api.reload('e280bc14', component.options)
    }
    module.hot.accept("./menu-compo-grid.vue?vue&type=template&id=e280bc14", function () {
      api.rerender('e280bc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/menu-compo-grid.vue"
export default component.exports